/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("HoverImageTiles", ["jquery", "Behaviors"], factory);
    } else {
        root.HoverImageTiles = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function HoverImageTiles() {
        Behaviors.init(HoverImageTiles, this, arguments);

        if (jQuery(window).width() > 992) {
            var item = this.$elem.find(HoverImageTiles.ELEMENTS.hoverTileItem);
            var image = this.$elem.find(HoverImageTiles.ELEMENTS.hoverTileMainBgImage);
            
            item.on('mouseenter', function() {
                
                var imageTarget = jQuery(this).data("image");

                if(!jQuery(this).hasClass('HoverImageTiles--active_item')) {
                    item.removeClass('HoverImageTiles--active_item');
                    jQuery(this).addClass('HoverImageTiles--active_item');
                    
                    image.removeClass('HoverImageTiles-item--active');
                    jQuery('.' + imageTarget).addClass('HoverImageTiles-item--active');
                }

            })

        }
    }

    Behaviors.inherit(HoverImageTiles, Behaviors.Behavior);

    HoverImageTiles.QUERY = "[data-HoverImageTiles-toggle]";

    HoverImageTiles.ELEMENTS = {
        hoverTileItem: ".HoverImageTiles-item",
        hoverTileMainBgImage: ".HoverImageTiles-items_bg_image",
        hoverTileMainContent: ".HoverImageTiles-item_content-text_link_wrap"
    };
    
    Behaviors.register_behavior(HoverImageTiles);

    module.HoverImageTiles = HoverImageTiles;

    return module;
}));
